import DocumentSelectorModal from './DocumentSelectorModal'

export default DocumentSelectorModal
